// @flow
import React from "react";
import { useSelector } from "react-redux";

import { Translate } from "@quantum/i18n";

import {
  SelecaoCasasDecimais,
  SelecaoPeriodo,
  SelecaoPeriodicidade,
  SelecaoAjusteDias,
  SelecaoHorizonteDu,
  SelecaoConfianca,
  SelecaoBenchmark,
  SelecaoJanelaMovel,
} from "../configuracoes";
import {
  comGeradorDePeriodo,
  getEdicaoMedida,
  getDataBaseSelecionadaAsString,
  isModoSeries,
  analiseValorDaMedida,
} from "../../../state";
import { truncate } from "../../../util/index";

export const processarPeriodoComBenchmarkHc = comGeradorDePeriodo(
  (state, medidas) => {
    const edicaoMedida = getEdicaoMedida(state);
    const dataBase = getDataBaseSelecionadaAsString(state);
    const modoSeries = isModoSeries(state);

    if (modoSeries) {
      return medidas.map(medidaSelecionada => ({
        ...medidaSelecionada,
        descricaoSelecao: "",
        horizonte: edicaoMedida.horizonte,
        confianca:
          edicaoMedida.confianca && truncate(edicaoMedida.confianca / 100, 2),
        benchmark: edicaoMedida.benchmark,
        janelaMovel: edicaoMedida.janelaMovel,
        ...analiseValorDaMedida(medidaSelecionada, state),
      }));
    } else {
      return medidas.map(medidaSelecionada => ({
        ...medidaSelecionada,
        descricaoSelecao: "",
        periodicidade: edicaoMedida.periodicidade,
        ajusteDias: edicaoMedida.ajusteDias,
        horizonte: edicaoMedida.horizonte,
        confianca:
          edicaoMedida.confianca && truncate(edicaoMedida.confianca / 100, 2),
        benchmark: edicaoMedida.benchmark,
        dataBase: dataBase,
        janelaMovel: edicaoMedida.janelaMovel,
        ...analiseValorDaMedida(medidaSelecionada, state),
      }));
    }
  }
);

const PeriodoComBenchmarkHc = () => {
  const modoSeries = useSelector(isModoSeries);

  if (modoSeries) {
    return (
      <>
        <div className="ConfiguracaoMedida">
          <SelecaoBenchmark />
        </div>

        <div className="ConfiguracaoMedida__vertical-divider" />

        <div className="ConfiguracaoMedida">
          <h3 className="ConfiguracaoMedida__group-title">
            <Translate>configuracaoRelatorio.parametros</Translate>
          </h3>
          <div className="ConfiguracaoMedida__group--grey">
            <div className="ConfiguracaoMedida__box">
              <SelecaoHorizonteDu className="ConfiguracaoMedida__input--auto" />
            </div>
            <div className="ConfiguracaoMedida__box">
              <SelecaoConfianca className="ConfiguracaoMedida__input--auto" />
            </div>
          </div>
        </div>

        <div className="ConfiguracaoMedida__vertical-divider" />

        <div className="ConfiguracaoMedida">
          <SelecaoJanelaMovel />
        </div>
      </>
    );
  } else {
    return (
      <div className="ConfiguracaoMedida--no-flex">
        <div className="ConfiguracaoMedida--row">
          <SelecaoBenchmark />
          <SelecaoCasasDecimais />
        </div>

        <div className="ConfiguracaoMedida__horizontal-divider" />

        <div className="ConfiguracaoMedida--row">
          <div className="ConfiguracaoMedida--flex">
            <SelecaoPeriodo exibirPeriodicidade={false} />
          </div>

          <div className="ConfiguracaoMedida">
            <div className="ConfiguracaoMedida__box">
              <SelecaoPeriodicidade />
            </div>

            <div className="ConfiguracaoMedida__box">
              <SelecaoAjusteDias />
            </div>
          </div>

          <div className="ConfiguracaoMedida__vertical-divider" />

          <div className="ConfiguracaoMedida">
            <h3 className="ConfiguracaoMedida__group-title">
              <Translate>configuracaoRelatorio.parametros</Translate>
            </h3>
            <div className="ConfiguracaoMedida__group--grey">
              <div className="ConfiguracaoMedida__box">
                <SelecaoHorizonteDu className="ConfiguracaoMedida__input--auto" />
              </div>
              <div className="ConfiguracaoMedida__box">
                <SelecaoConfianca className="ConfiguracaoMedida__input--auto" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default PeriodoComBenchmarkHc;
